import i18n from '@/locales/index'
const { t } = i18n.global
import { ElLoading } from 'element-plus';
const APP_ENV = process.env.APP_ENV
const fileUrl = '/admin/file/fileDownload?filePath='
const loading = {
  instance: null,
  open: function(options={}) {
    this.instance = ElLoading.service({
      text: t('common.utils.loading'),
      background: 'rgba(50,50,50,.1)',
      ...options
    })
  },
  close: function() {
    this.instance && this.instance.close()
  }
}
window.loading = loading;


const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${[year, month, day].map(formatNumber).join('-')}`
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : `0${n}`
}

function getUrlParams (path) {
  if (!path) return
  path = decodeURIComponent(path)
  var data = {}
  var reg = new RegExp('([^?=&]+)(=([^&]*))?', 'g')
  path && path.replace(reg, function ($0, $1, $2, $3) {
    data[$1] = $3
  })
  return data
}

function getUrlParam (path, name) {
  path = decodeURIComponent(path)
  const reg = new RegExp('(^|&|\\?)' + name + '=([^&]*)(&|$)')
  const res = path.match(reg)
  let value = ''
  if (res) {
    value = res[2]
  }
  return value
}

const intValidator = ({ min, max, label }) => {
  return [
    {
      required: label == '' ? false : true,
      message: t('common.utils.enterX', {label: label}),
      trigger: "blur",
    },
    {
      pattern: /^[0-9]+$/,
      message: t('common.utils.enterValidPositiveInteger'),
      trigger: "blur",
    },
    {
      validator: (rule, value) => {
        const intValue = parseInt(value);
        const minValue = min || 0; // 设置最小值
        const maxValue = max || 9999999; // 设置最大值
        if (intValue < minValue || intValue > maxValue) {
          return Promise.reject(
            t('common.utils.notInValidRange', {min: minValue, max: maxValue})
          );
        } else {
          return Promise.resolve();
        }
      },
      trigger: "blur",
    },
  ];
};

const getFilePath = () =>{
  console.log
  const url = APP_ENV == "dev" ? "https://ota.uat.jaka.com" + fileUrl : `${window.location.origin}${fileUrl}`
 return url
}

export {
  loading,
  formatTime,
  getUrlParam,
  getUrlParams,
  intValidator,
  getFilePath,
}
